import classNames from "classnames/bind";
import { IconProps } from "common/assets/icons/types";
import * as React from "react";
import styles from "./Icon.module.css";

const classNameBuilder = classNames.bind(styles);

export const MedalIcon: React.FC<IconProps> = ({
  color = "#fd6a65",
  withBackground,
}) => {
  const renderContent = (): React.JSX.Element => {
    return (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g fill="none" fillRule="evenodd">
          <path d="M0 0h32v32H0z" />
          <g fill={color}>
            <path
              d="M8.774 13a7.226 7.226 0 1 1 14.452 0 7.226 7.226 0 0 1-14.452 0Z"
              fillRule="nonzero"
              opacity=".12"
            />
            <path d="M16 5a8 8 0 0 0-4.927 14.303l-1 7.007a.774.774 0 0 0 1.053.828L16 25.188l4.874 1.95a.774.774 0 0 0 1.054-.828l-1.001-7.007A8 8 0 0 0 16 5Zm3.49 15.2c-1.054.513-2.238.8-3.49.8a7.967 7.967 0 0 1-3.49-.8l-.716 5.003 3.919-1.567a.774.774 0 0 1 .574 0l3.919 1.567-.715-5.003ZM9.549 13a6.452 6.452 0 1 1 12.904 0 6.452 6.452 0 0 1-12.904 0Z" />
          </g>
        </g>
      </svg>
    );
  };

  if (withBackground) {
    return (
      <div
        className={classNameBuilder({
          withBackground,
        })}
      >
        {renderContent()}
      </div>
    );
  }

  return renderContent();
};
